export var CheckpointInputType = /* @__PURE__ */ ((CheckpointInputType2) => {
  CheckpointInputType2["START"] = "start";
  CheckpointInputType2["STOP"] = "stop";
  CheckpointInputType2["END"] = "end";
  return CheckpointInputType2;
})(CheckpointInputType || {});
